<div
	class="relative overflow-hidden rounded-xl bg-white drop-shadow-md"
	[class]="toast().customClass"
>
	<div class="flex w-full items-center gap-2 px-3.5 py-4 pb-[18px]">
		<div class="self-start">
			<lbca-icon [name]="toast().icon || ''" [color]="toast().color || ''" size="mdlg" />
		</div>
		<div class="mt-1 grow text-base">
			<div class="flex justify-between gap-2">
				<p class="font-medium text-gray-800">{{ toast().title }}</p>
				@if (toast().closable) {
					<div (click)="removeToast()" class="text-[1.2rem]">
						<lbca-icon
							customClass="cursor-pointer hover:text-gray-900"
							name="lucide:x"
							color="gray"
							size="auto"
						/>
					</div>
				}
			</div>
			@if (toast().message) {
				<p class="mt-1 max-h-56 overflow-y-auto text-gray-600">
					{{ toast().message }}
				</p>
			}
		</div>
		<div class="cursor-pointer"></div>
	</div>

	@if (toast().showProgress) {
		<div
			class="absolute bottom-0 left-0 h-[5px] w-full bg-opacity-35 ease-linear"
			[class]="toast().bgColor"
		></div>
		<div
			class="absolute bottom-0 left-0 h-[5px] transition-[width] ease-linear"
			[class]="toast().bgColor"
			[style.transition-duration.ms]="(toast().duration || 3000) - 50"
			[style.width.%]="toast().progress"
		></div>
	}
</div>
